export const loginType = {
  EMAIL: 'normal',
  GOOGLE: 'google',
};
